export default {
  assignedToMe: 'Priradené mne',
  selectInReviewState: 'Vybrať úlohy na kontrolu',
};
